const GeometricOverlay = () => (
  <svg
    className="absolute inset-0 w-full h-full pointer-events-none z-10"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <line
      x1="10%"
      y1="0"
      x2="90%"
      y2="100%"
      stroke="hsl(var(--geometric-line))"
      strokeWidth="0.5"
      opacity="0.12"
      className="geometric-line"
    />
    <line
      x1="30%"
      y1="0"
      x2="70%"
      y2="100%"
      stroke="hsl(var(--geometric-line))"
      strokeWidth="0.5"
      opacity="0.08"
      className="geometric-line geometric-line-delayed"
    />
    <line
      x1="85%"
      y1="0"
      x2="15%"
      y2="100%"
      stroke="hsl(var(--geometric-line))"
      strokeWidth="0.5"
      opacity="0.1"
      className="geometric-line geometric-line-delayed-2"
    />
    <line
      x1="0"
      y1="40%"
      x2="100%"
      y2="60%"
      stroke="hsl(var(--geometric-line))"
      strokeWidth="0.5"
      opacity="0.06"
      className="geometric-line geometric-line-delayed"
    />
  </svg>
);

export default GeometricOverlay;
